module.exports = __webpack_public_path__ + "static/media/life-sciences.59a58890.jpg";